
import { Component, Input, OnInit, Directive } from '@angular/core';
import ScrollReveal from 'scrollreveal'
@Component({
  selector: 'app-block-text-img',
  templateUrl: './block-text-img.component.html',
  styleUrls: ['./block-text-img.component.scss']
})
export class BlockTextImgComponent implements OnInit {


  @Input() left?: boolean

  constructor() { }

  ngOnInit(): void {

  }
  ngAfterViewInit(): void {


    const sr = ScrollReveal();

      sr.reveal('.img-one', { duration: 3000, distance: '150%', origin: 'left', mobile: false });
      sr.reveal('.bg-img-one', { duration: 3000, delay: 500, distance: '150%', origin: 'left', mobile: false });
      sr.reveal('.bg-img-two', { duration: 3000, delay: 500, distance: '150%', origin: 'right',mobile: false  });
      sr.reveal('.img-two', { duration: 3000, distance: '150%', origin: 'right',mobile: false  });
      sr.reveal('.img-diagonal', { duration: 3000, distance: '150%', origin: 'right', mobile: false  });

  }

}
